export class IconInputModel {
    type: string;
    src: string;
    disabled: boolean;
    placeholder: string;
    required: boolean;
    hidden: boolean;
}
